import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import headerBg from './header-bg.png'
import img1 from './img1.png'
import img2 from './img2.png'
import img3 from './img3.png'
import img4 from './img4.png'

const Kitchen = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="Design Your Dream Kitchen with Our Kitchen Design App"
        subtitle="Plan your kitchen layout, choose cabinets and decor, and visualize your remodel — all in one easy-to-use kitchen design app."
        bg={headerBg}
        meta={{
          title: 'Kitchen Design App | Design Your Kitchen Layout & Decor',
          description: 'Design your kitchen with our virtual kitchen design app. Plan layouts, place cabinets, and explore kitchen decor ideas. Visualize and customize your dream kitchen today.'
        }}
        alt="Design your dream kitchen layout with the DecorMatters kitchen design app using virtual planning tools and real furniture previews"
      />
      <Join title="Join 10 Million+ Users Designing Kitchens with" description="" />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Customize Your Kitchen Layout and Decor with Our Design App</H2>
            </Show>
            <Text>
              Design your kitchen layout, choose furniture, and test decor ideas — all in one app. The DecorMatters kitchen design app lets you explore styles, plan your space, and visualize your kitchen before making decisions. Add and arrange real
              pieces to bring your design to life, including:
              <br />
              <br />● Cabinets and counters
              <br />● Kitchen islands and carts
              <br />● Bar stools and dining chairs
              <br />● Lighting and pendant fixtures
              <br />● Rugs, plants, and wall decor
              <br />
              <br />
              You can build a portfolio of kitchen design ideas for inspiration and planning while shopping for your favorite brands. We have thousands of items from over 30 quality retailers!Whether you prefer modern, farmhouse, or minimalist
              styles, our kitchen app helps you design a space that fits your taste and needs.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Customize Your Kitchen Layout and Decor with Our Design App</H2>
            </Show>
            <Image src={img1} alt="Customize your kitchen layout with cabinets, islands, lighting, and decor using our kitchen layout planner app" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Remodel Your Kitchen with Confidence Using Our App</H2>
            </Show>
            <Text>
              Kitchen remodels offer one of the highest returns on investment, and with the DecorMatters kitchen design app, you can plan every detail with confidence. Avoid costly mistakes by visualizing your layout before committing. Try different
              cabinet styles, test flooring and finishes, and experiment with decor — all virtually from your phone. Whether you’re planning a small update or a full renovation, our app helps you make smarter, faster decisions that bring your kitchen
              ideas to life.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Remodel Your Kitchen with Confidence Using Our App</H2>
            </Show>
            <Image src={img2} alt="Plan your kitchen remodel and test layout ideas virtually with the DecorMatters kitchen remodeling app" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Unlock Premium Tools to Design Your Kitchen Like a Pro</H2>
            </Show>
            <Text>
              Take your kitchen design to the next level with DecorMatters Premium. Access exclusive features that help you personalize every detail of your space, from layout planning to final finishes. Upload real photos of your kitchen, test
              furniture with AR, and organize your favorite products — all in one powerful workspace design app.
              <br />
              <br />
              ● Upload real kitchen photos for accurate virtual planning
              <br />
              ● Use AR to preview furniture and decor in your space
              <br />
              ● Save and organize the kitchen products you love
              <br />
              ● Erase backgrounds for cleaner layout visuals
              <br />● Unlock exclusive tools for faster kitchen remodeling
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Unlock Premium Tools to Design Your Kitchen Like a Pro</H2>
            </Show>
            <Image src={img3} alt="Unlock premium features in the DecorMatters kitchen interior design app for accurate virtual kitchen planning and augmented reality tools" />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Start Designing Now
              </ButtonLink>
            </Show>
            <Image src={img4} alt="Download the DecorMatters kitchen design app to visualize your kitchen renovation, arrange furniture, and decorate your space" />
            <Content>
              <H2>Start Designing Your Dream Kitchen Today</H2>
              <Text>
                Download the DecorMatters kitchen design app to plan your layout, test real furniture, and decorate with ease. Whether you're remodeling your kitchen or updating a few elements, our virtual kitchen design app gives you the tools to
                visualize, customize, and create your perfect cooking space — right from your phone.
              </Text>
              <Show on="desktop">
                <ButtonLink href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467" target="_blank">
                  Start Designing Now
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default Kitchen
